"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayedStockItem = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../../BaseAvroRecord");
class DisplayedStockItem extends BaseAvroRecord_1.BaseAvroRecord {
    schema() {
        return DisplayedStockItem.schema;
    }
    subject() {
        return DisplayedStockItem.subject;
    }
}
exports.DisplayedStockItem = DisplayedStockItem;
DisplayedStockItem.subject = "displayed-stock-item";
DisplayedStockItem.schema = {
    "type": "record",
    "name": "DisplayedStockItem",
    "namespace": "storyblocks.content.records",
    "fields": [
        {
            "name": "position",
            "type": "int"
        },
        {
            "name": "stockItem",
            "type": {
                "type": "record",
                "name": "ShallowStockItem",
                "fields": [
                    {
                        "name": "stockItemId",
                        "type": "int"
                    },
                    {
                        "name": "contentId",
                        "type": [
                            "null",
                            "int"
                        ],
                        "default": null
                    },
                    {
                        "name": "title",
                        "type": "string"
                    },
                    {
                        "name": "distributionType",
                        "type": {
                            "type": "enum",
                            "name": "DistributionType",
                            "namespace": "storyblocks.content.enums",
                            "symbols": [
                                "MEMBER_LIBRARY",
                                "REV_SHARE",
                                "MARKETPLACE",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "publishedDate",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "distributionTypeUpdatedDate",
                        "type": [
                            "null",
                            {
                                "type": "long",
                                "logicalType": "timestamp-millis"
                            }
                        ],
                        "default": null
                    },
                    {
                        "name": "contentType",
                        "type": {
                            "type": "enum",
                            "name": "ContentType",
                            "namespace": "storyblocks.content.enums",
                            "symbols": [
                                "ALL",
                                "LOOPS",
                                "MUSIC",
                                "SOUND_EFFECTS",
                                "ILLUSTRATIONS",
                                "PHOTOS",
                                "SNAPSHOTS",
                                "VECTORS",
                                "FOOTAGE",
                                "MOTION_BACKGROUNDS",
                                "TEMPLATES",
                                "VR_360",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "format",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "thumbnailUrl",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    }
                ]
            }
        }
    ]
};
//# sourceMappingURL=DisplayedStockItem.js.map